import { WithMsalProps } from '@azure/msal-react'
import { inject } from 'mobx-react'
import React from 'react'
import type { AuthStore } from './types'

type DecoratorProps = {
  authStore: AuthStore
} & WithMsalProps

const withUser = (WrappedComponent: any): any => {
  @inject('authStore')
  class Decorator extends React.PureComponent<DecoratorProps> {
    render() {
      const { authStore, ...props } = this.props

      return <WrappedComponent user={authStore.getUser()} {...props} />
    }
  }

  return Decorator
}

export default withUser
